module.exports = __webpack_public_path__ + "img/left_item_bg.d547b7d3.png";